import { Button, Divider } from "components";
import { useFormikContext } from "formik";
import GoogleSignInButton from "pages/accounts-onboarding/components/google-signin-button";
import TermsAcceptance from "pages/accounts-onboarding/components/terms-acceptance";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Paths from "routes/Paths";

import type { RegisterFormModel } from "../../models";

import styles from "../Register.module.css";

const RegisterFooter = () => {
	const { t } = useTranslation("accountsPage");
	const { isSubmitting, setFieldTouched, values } = useFormikContext<RegisterFormModel>();
	// Keep the post-sign-in redirect when switching to the sign-in form.
	const { search } = useLocation();

	// Google never reaches Formik's submit, so a missing tick has to be surfaced by hand. Touching
	// the field is enough — the checkbox renders the schema's message the moment it is touched.
	const onConsentRequired = useCallback((): void => {
		setFieldTouched("acceptedTerms", true);
	}, [setFieldTouched]);

	return (
		<footer className={styles.footer}>
			{/* Above the buttons, not below them: it has to be read before it is acted on, and it
			    replaces the passive notice that used to sit at the bottom of this form. */}
			<TermsAcceptance />
			<Button disabled={isSubmitting} type="submit" fullWidth>
				{t("register.submit")}
			</Button>
			<Divider label={t("continueWith")} />
			<GoogleSignInButton acceptedTerms={values.acceptedTerms} onConsentRequired={onConsentRequired} />
			<div className={styles.signIn}>
				<span>{t("register.haveAccount")}</span>
				<Link className={styles.signInLink} to={{ pathname: Paths.signIn, search }}>
					{t("register.signIn")}
				</Link>
			</div>
		</footer>
	);
};

export default RegisterFooter;
